var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch"},[_c('elSwitch',{attrs:{"value":_vm.value,"disabled":_vm._disabled},on:{"change":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }